import { IDWorkerLookupLayout, IDWarehouseLookupLayout } from "../../../../../../common/lookups/Layouts/IdLayouts";
import { WMCodesLookupLayout } from "../../../../../../common/lookups/Layouts/WMLayouts";
import { CodeLookupLayout, CrateDPLookup, IMLocationLookupLayout, LocationDpLookupLayout } from "../../../../../../common/lookups/Layouts/ImLayouts";
import { IM, WM } from "../../../../../../const/constants";
import { ActivityLayout, CAJobLayout } from '../../../../../../common/lookups/Layouts/CALayouts';
const runtimeParameter = JSON.stringify([
    { None: '' }]);
const locationLookupLayout = IMLocationLookupLayout({ moduleType: WM, runtimeParameter })

const GenerateItemTasksLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "GenerationMethod",
                "tableName": "",
                "localizedField": "Keysequence",
                "label": "Generation Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "showClearButton": true
            },
            {
                "name": "PutawayWorker",
                "tableName": "",
                "label": "Putaway By",
                "type": "lookup",
                "layout": IDWorkerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnloadWorker",
                "tableName": "",
                "label": "Load By",
                "type": "lookup",
                "layout": IDWorkerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RFgroup",
                "tableName": "",
                "label": "RF Group",
                "type": "lookup",
                layout: WMCodesLookupLayout({ codeType: 'S6' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "RWarehouse",
                "tableName": "",
                "label": "Staging WH",
                "type": "lookup",
                layout: IDWarehouseLookupLayout,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RLocatoin",
                "tableName": "",
                "label": "Staging Location",
                "type": "lookup",
                "layout": locationLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                name: "RCaactivityPutawayby",
                tableName: "",
                label: "Put Activity",
                type: "lookup",
                "layout": ActivityLayout,
                required: false,
                visible: true
            },
            {
                name: "RCaactivityUnloadby",
                tableName: "",
                label: "Load Activity",
                type: "lookup",
                "layout": ActivityLayout,
                required: false,
                visible: true
            }
        ]
    }
];

export {
    GenerateItemTasksLayout,
}